module.exports = __webpack_public_path__ + "media/images/icon-menu-active-f85560dcceec6838b5206113380e2ddd.svg";